import FilterDirection from "./FilterDirection";

const FilterButton = (props) => {

    const {
        activeFilter,
        setActiveFilter,
        filterOrder,
        setFilterOrder,
        value,
        text,
        classes
    } = props;


  const toggleDirection = () => {
    if (filterOrder === "asc") {
      setFilterOrder("desc");
    } else {
      setFilterOrder("asc");
    }
  };

  return (
    <button
      className={`archive__filter-button ${
        activeFilter === value ? "active" : ""
      } ${classes}`}
      onClick={()=>{
        setActiveFilter(value);
        toggleDirection();
      }}
    >
      {text}
      {activeFilter === value && filterOrder === "asc" ? (
            <FilterDirection direction="asc" />
          ) : (
            ""
          )}
          {activeFilter === value && filterOrder === "desc" ? (
            <FilterDirection direction="desc" />
          ) : (
            ""
          )}
    </button>
  );
};

export default FilterButton;
